export class SunburstConfig {
  colors: Array<string>;
  constructor(colors: Array<string>) {
    this.colors = colors || [];
  }
}